import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh.json'
import zhTw from './zh-tw.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import th from './thai.json'
import jp from './jp.json'
import ru from './ru.json'
import pt from './pt.json'
import ar from './ar.json'
import el from './el.json'
import VuetifyZH from 'vuetify/lib/locale/zh-Hans'
import VuetifyZHTW from 'vuetify/lib/locale/zh-Hant'
import VuetifyEN from 'vuetify/lib/locale/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import elementZhTw from 'element-ui/lib/locale/lang/zh-TW'
import elementEn from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)
//判断浏览器语言
let lang = navigator.language || navigator.browserLanguage
if (lang.toLowerCase() === 'zh-tw' || lang.toLowerCase() === 'zh-hant') {
  lang = 'zh-tw'
} else if (lang.toLowerCase().indexOf('zh') !== -1) {
  lang = 'zh'
} else if (lang.toLowerCase().indexOf('es') !== -1) {
  lang = 'es'
} else if (lang.toLowerCase().indexOf('fr') !== -1) {
  lang = 'fr'
} else if (lang.toLowerCase().indexOf('th') !== -1) {
  lang = 'th'
} else if (lang.toLowerCase().indexOf('ru') !== -1) {
  lang = 'ru'
} else if (lang.toLowerCase().indexOf('jp') !== -1) {
  lang = 'jp'
} else if (lang.toLowerCase().indexOf('pt') !== -1) {
  lang = 'pt'
} else if (lang.toLowerCase().indexOf('ar') !== -1) {
  lang = 'ar'
} else if (lang.toLowerCase().indexOf('el') !== -1) {
  lang = 'el'
} else {
  lang = 'en'
}

//判断已设置语言
let language = localStorage.getItem('language')
if (language == 'zh-cn') {
  lang = 'zh'
} else if (language == 'zh-tw') {
  lang = 'zh-tw'
} else if (language == 'es-es') {
  lang = 'es'
} else if (language == 'fr-fr') {
  lang = 'fr'
} else if (language == 'th-th') {
  lang = 'th'
} else if (language == 'ja-jp') {
  lang = 'jp'
} else if (language == 'ru-ru') {
  lang = 'ru'
} else if (language == 'en-us') {
  lang = 'en'
} else if (language == 'pt-pt') {
  lang = 'pt'
} else if (language == 'ar-sa') {
  lang = 'ar'
} else if (language == 'el-gr') {
  lang = 'el'
}

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages: {
    zh: {
      ...zh,
      ...VuetifyZH,
      ...elementZh,
    },
    'zh-tw': {
      ...zhTw,
      ...VuetifyZHTW,
      ...elementZhTw,
    },
    en: {
      ...en,
      ...VuetifyEN,
      ...elementEn,
    },
    es: {
      ...es,
    },
    fr: {
      ...fr,
    },
    th: {
      ...th,
    },
    jp: {
      ...jp,
    },
    ru: {
      ...ru,
    },
    pt: {
      ...pt,
    },
    ar: {
      ...ar,
    },
    el: {
      ...el,
    },
  },
})

export default i18n
